import React, { Component } from 'react';
import '../css/header.css';

class HeaderOption extends Component {

  render() {
    return (
      <span className="header-option">
        <a href={this.props.url}>
          {this.props.option}
        </a>
      </span>
    );
  }
}

export default HeaderOption;
